import { axiosInstance, axiosRequestWithAuth, API_HOST } from './../constants/server.constant';
import { getLocalTime, getFullRegionDetail } from '../utility/utility';

export const ServerService = {
    getServerList,
    getServerDetailsById,
    getServerListByRegion,
    getRegionListByType,
    getImageDetailsByRegion,
    getFlavorDetailsByRegion,
    getSshKeyByRegion,
    createServer,
    createCloneServer,
    deleteServer,
    rebootServer,
    startServer,
    stopServer,
    serverAction,
    launchConsole,
    getActivities,
    updateServer,
    serverActionRebuild,
    getlcUrl,
    getlcUrl_v2,
    serverActionResize,
    serverActionResize_v2,
    getCloneStatus,
    getCloneList,
    submitBmr,
    validateServer,
    deleteBMServer,
    createSurvey,
    getSurvey,
    isSurveyEnabled,
    getSureyList,
    deleteSurveyById,
    instMigration,
    migration,
    instReject,
    getAllKbInfo
};

function getUserId() {
    return localStorage.getItem('userId');
}

async function getServerList(isNonCached) {

    return await axiosInstance.get(`/server/` + getUserId() + '?isNonCached=' + isNonCached, axiosRequestWithAuth)
        .then(resp => {
            let items = resp.data;

            let instCountList = [];
            let fullRegionList = JSON.parse(localStorage.getItem('fullRegionList'));
            if(items === undefined) {
                return resp;
            }
            let servers = [];
            for(var item of Object.keys(items)) {
                const locItem = item;
                let serverList = items[locItem];
                if(serverList === undefined || serverList === null) {
                    continue;
                }

                instCountList.push({ key: item, count: serverList.length });
                let fullRegion = getFullRegionDetail(fullRegionList, locItem);

                serverList.forEach(server => {
                    let d = new Date(server.created);
                    let createdDate = d.toLocaleString('default', { month: 'short' }) + ' ' + d.getDate() + ',  ' + d.getFullYear() + ' ' + d.toLocaleString([], {
                        hour: '2-digit',
                        minute: '2-digit'
                    });
                    let ipAddress = getPublicIpAddress(server.addresses);
                    servers.push({
                        id: server.id,
                        name: server.name,
                        ipaddress: ipAddress,
                        region: locItem,
                        status: server.status,
                        createdOn: createdDate,
                        progress: server.progress,
                        userId: server.user_id,
                        links: server.links,
                        flavor: server.flavor,
                        image: server.image,
                        security_groups: server.security_groups,
                        addresses: server.addresses,
                        vmstate: server["OS-EXT-STS:vm_state"],
                        taskState: server["OS-EXT-STS:task_state"],
                        fullRegion: fullRegion,
                        fault: server?.fault,
                        metadata: server.metadata
                    });
                });
            }
            localStorage.setItem('instCountList', JSON.stringify(instCountList));
            return servers;
        }).catch(function (error) {
            return error;
        });
}

async function getServerDetailsById(regionUrl, id) {
    return await axiosInstance.get('/server/' + getUserId() + '/' + id + '?region=' + regionUrl, axiosRequestWithAuth)
        .then(response => {
            let resp = response.data;
            let server = resp.server;
            let d = new Date(server.created);
            let createdDate = d.toLocaleString('default', { month: 'short' }) + ' ' + d.getDate() + ',  ' + d.getFullYear() + ' ' + d.toLocaleString([], {
                hour: '2-digit',
                minute: '2-digit'
            });
            let ipAddress = getPublicIpAddress(server.addresses);
            let task_state = server["OS-EXT-STS:task_state"];
            if(server.status === 'MIGRATING' || task_state === 'migrating') {
                server.status = 'ACTIVE';
                server.taskState = null;
            }
            return {
                id: server.id,
                name: server.name,
                ipaddress: ipAddress,
                status: server.status,
                createdOn: createdDate,
                progress: server.progress,
                userId: server.user_id,
                links: server.links,
                flavor: server.flavor,
                image: server.image,
                security_groups: server.security_groups,
                addresses: server.addresses,
                vmstate: server["OS-EXT-STS:vm_state"],
                taskState: task_state,
                fault: server?.fault,
                metadata: server.metadata
            };
        }).catch(function (error) {
            return [];
        });
}



async function getServerListByRegion(regionUrl) {
    return await axiosInstance.get(`/server/region/` + getUserId() + '?region=' + regionUrl, axiosRequestWithAuth)
        .then(resp => {
            let serverList = resp.data;
            let servers = [];
            if(serverList === undefined || serverList === null) {
                return servers;
            }
            for(var server of serverList) {
                // let d = new Date(server.created);
                // let createdDate = d.toLocaleString('default', { month: 'short' }) + ' ' + d.getDate() + ',' + d.getFullYear() + ' ' + d.toLocaleString([], {
                //     hour: '2-digit',
                //     minute: '2-digit'
                // });
                let ipAddress = getPublicIpAddress(server.addresses);
                servers.push({
                    id: server.id,
                    name: server.name,
                    ipaddress: ipAddress,
                    status: server.status,
                    createdOn: server.created,
                    progress: server.progress,
                    userId: server.user_id,
                    flavorId: server.flavor.id,
                    security_groups: server.security_groups,
                    vmstate: server["OS-EXT-STS:vm_state"],
                    taskState: server["OS-EXT-STS:task_state"],
                    fault: server?.fault,
                });
            }
            return servers;
        }).catch(function (error) {
            return [];
        });
}

async function getRegionListByType(type) {
    return await axiosInstance.get(`/regions/` + type, axiosRequestWithAuth)
        .then(resp => {
            let regions = resp.data;
            return regions;
        }).catch(function (error) {
            return [];
        });
}

async function getCloneStatus() {
    return await axiosInstance.get(`/server/` + getUserId() + `/clone-status`, axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return [];
        });
}

async function getCloneList(type) {
    return await axiosInstance.get(`/notifications/` + type + '/' + getUserId(), axiosRequestWithAuth)
        .then(resp => {
            let items = resp.data;
            if(items && Array.isArray(items)) {
                items.forEach(elem => {
                    if(!elem.startTime.includes('Z')) {
                        elem.startTime = elem.startTime + 'Z';
                    }
                    elem.createdDate = getLocalTime(elem.startTime);
                });
            }

            return resp.data;
        }).catch(function (error) {
            return [];
        });
}

async function getImageDetailsByRegion(regionUrl) {

    let transformedFlavor = {
        distributionImages: [],
        images: [],
        applicationStack: [],
        bareMetalImages: []
    };
    return await axiosInstance.get('/images/' + getUserId() + '?region=' + regionUrl, axiosRequestWithAuth)
        .then(resp => {
            let data = resp.data;
            if(data.images && data.images.length > 0) {
                data.images.forEach(flavor => {
                    let flavorName = flavor.name.split("-");
                    flavor.distribution = flavorName[0];
                    flavor.version = flavorName[1];
                    flavor.instructionSet = flavorName[2];
                    if(flavor.status !== 'active') return;
                    if(flavor.visibility === 'public' && flavor.tags && flavor.tags.length > 0) {
                        flavor.tags.forEach(key => {
                            if(key === 'x86_64') {
                                transformedFlavor.distributionImages.push(flavor);
                            }
                            else if(key === 'bare_metal') {
                                transformedFlavor.bareMetalImages.push(flavor);
                            }
                            else if(key === 'application_stack') {
                                try {
                                    var rawName = flavor.name.split('-');
                                    let checkRawName = rawName[0];
                                    flavor.rawName = rawName[0];
                                    if(checkRawName !== undefined && rawName[0].includes(':')) {
                                        var splitName = checkRawName.split(':');
                                        flavor.rawName = splitName[0];
                                        flavor.nameDesc = splitName[1];
                                    }
                                    flavor.os = rawName[1];
                                    flavor.version = rawName[2];
                                }
                                catch(err) {
                                    console.log(err);
                                }
                                transformedFlavor.applicationStack.push(flavor);
                            }
                        });
                    } else if(flavor.visibility === 'private') {
                        transformedFlavor.images.push(flavor);
                    }
                });
                if(transformedFlavor.distributionImages && transformedFlavor.distributionImages.length > 0) {
                    transformedFlavor.distributionImages.sort(function (a, b) {
                        return b.version - a.version;
                    });
                }
                if(transformedFlavor.applicationStack && transformedFlavor.applicationStack.length > 0) {
                    transformedFlavor.applicationStack.sort(function (a, b) {
                        if(a.rawName.toLowerCase() < b.rawName.toLowerCase()) { return -1; }
                        if(a.rawName.toLowerCase() > b.rawName.toLowerCase()) { return 1; }
                        return 0;
                    });
                }
                if(transformedFlavor.images && transformedFlavor.images.length > 0) {
                    transformedFlavor.images.sort(function (a, b) {
                        if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                        if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                        return 0;
                    });
                }
                return transformedFlavor;
            }
        }).catch(function (error) {
            return transformedFlavor;
        });
}

async function getFlavorDetailsByRegion(regionUrl) {
    let plans = [];
    return await axiosInstance.get('/flavors/' + getUserId() + '?region=' + regionUrl, axiosRequestWithAuth)
        .then(resp => {
            let data = resp.data;

            if(data === undefined || data === null) {
                return plans;
            }
            data.forEach(elem => {
                let newElem = {
                    id: elem.flavour_id,
                    monthlyRate: elem.monthly_price,
                    type: elem.type
                };
                let nameArr = elem.name.split(' ');


                let regandtype = nameArr[0].toString().split('/');
                newElem.planName = nameArr[1];
                newElem.region = regandtype[0];
                newElem.parenttype = regandtype[1];
                if(nameArr[1] !== undefined) {
                    let details = nameArr[1].toString().split('/');
                    newElem.ram = elem.ram / 1024 + ' GB';
                    let cpu = ' CPU';
                    if(elem.vcpus > 1) {
                        cpu = ' CPUs';
                    }
                    newElem.processor = elem.vcpus + cpu;
                    newElem.storage = elem.disk + ' GB';
                    newElem.hourlyRate = parseFloat(newElem.monthlyRate / (28 * 24)).toFixed(4);
                    newElem.bandwidth = elem.bandwidth;
                } else {
                    newElem.ram = '';
                    newElem.processor = '';
                    newElem.storage = '';
                }
                newElem.type = elem.type;
                plans.push(newElem);
            });
            return plans;
        }).catch(function (error) {
            return false;
        });
}
async function getSshKeyByRegion(regionUrl) {
    let sshKeys = [];
    if(localStorage.getItem("roleId") === "2") {
        return await axiosInstance.get('/ssh/' + getUserId() + '?region=' + regionUrl, axiosRequestWithAuth)
            .then(resp => {
                let data = resp.data;
                for(let items = 0; items < data.length; items++) {
                    let locSsh = data[items];
                    if(locSsh === undefined || locSsh === null) {
                        return sshKeys;
                    }
                    locSsh.keypairs.forEach(elem => {
                        sshKeys.push({
                            public_key: elem.keypair.public_key,
                            name: elem.keypair.name,
                        });
                    });

                }
                return sshKeys;

            }).catch(function (error) {
                return false;
            });
    }
    else {
        return await axiosInstance.get('/ssh/' + getUserId() + '?region=' + regionUrl, axiosRequestWithAuth)
            .then(resp => {
                let data = resp.data;
                if(data === undefined || data === null) {
                    return sshKeys;
                }
                data.keypairs.forEach(elem => {
                    sshKeys.push({
                        public_key: elem.keypair.public_key,
                        name: elem.keypair.name,
                    });
                });
                return sshKeys;
            }).catch(function (error) {
                return false;
            });
    }
}

async function createServer(requestBody, region) {
    let reqHeaders = JSON.parse(JSON.stringify(axiosRequestWithAuth));
    reqHeaders.timeout = 30000;
    return await axiosInstance.post('/server/' + getUserId() + '?region=' + region, requestBody, reqHeaders)
        .then(resp => {
            let data = resp.data;
            if(resp.message !== undefined && resp.message.includes('timeout') && data === undefined) {
                //console.log("in message :"+JSON.stringify(resp.message))
                data = { server: 'server created' };
            }
            if(data === undefined) {
                data = resp.response.data;
            }
            return data;
        }).catch(function (error) {
            if(error.message !== undefined && error.message.includes('timeout')) {
                let data = { server: 'server created' };
                return data;
            }
            if(error && error.response && error.response.data) return error.response.data;
            console.log("error :" + JSON.stringify(error));
            return error;
        });
}

async function validateServer(requestBody) {
    let reqHeaders = JSON.parse(JSON.stringify(axiosRequestWithAuth));
    return await axiosInstance.post('/server/validation/' + getUserId(), requestBody, reqHeaders)
        .then(resp => {
            let responses = resp.response;
            if(responses !== undefined) {
                return responses.data;
            }
            return resp.data;
        }).catch(function (error) {
            if(error && error.response && error.response.data) return error.response.data;
            console.log("error :" + JSON.stringify(error));
            return error;
        });
}

async function createCloneServer(requestBody, region) {
    let reqHeaders = JSON.parse(JSON.stringify(axiosRequestWithAuth));
    reqHeaders.timeout = 8000;

    return await axiosInstance.post('/server/instance-clone/' + getUserId() + '?region=' + region, requestBody, reqHeaders)
        .then(resp => {
            let data = resp.data;
            if(resp.message !== undefined && resp.message.includes('timeout') && data === undefined) {
                //console.log("in message :"+JSON.stringify(resp.message))
                data = { server: 'server created' };
            }
            if(data === undefined) {
                data = resp.response.data;
            }
            return data;
        }).catch(function (error) {
            if(error.message !== undefined && error.message.includes('timeout')) {
                let data = { server: 'server created' };
                return data;
            }
            console.log("error :" + JSON.stringify(error));
            return error;
        });
}

async function instMigration(requestBody, region) {
    let reqHeaders = JSON.parse(JSON.stringify(axiosRequestWithAuth));
    reqHeaders.timeout = 8000;

    return await axiosInstance.post('/server/inst-migration/' + getUserId() + '?region=' + region, requestBody, reqHeaders)
        .then(resp => {
            reqHeaders.timeout = 8000;
            let data = resp.data;
            if(resp.message !== undefined && resp.message.includes('timeout') && data === undefined) {
                //console.log("in message :"+JSON.stringify(resp.message))
                data = { server: 'server created' };
            }
            if(data === undefined) {
                data = resp.response.data;
            }
            return data;
        }).catch(function (error) {
            if(error.message !== undefined && error.message.includes('timeout')) {
                let data = { server: 'server created' };
                return data;
            }
            console.log("error :" + JSON.stringify(error));
            return error;
        });
}

async function deleteBMServer(serverId, region) {
    return await axiosInstance.delete(`/baremetal/deletebmr/` + serverId + "/" + getUserId() + '?region=' + region, axiosRequestWithAuth)
        .then(resp => {
            return true;
        }).catch(function (error) {
            return false;
        });
}

async function deleteServer(serverId, region, regionId, serverIp) {
    return await axiosInstance.delete(`/server/` + getUserId() + '/' + serverId + '?region=' + region + "&regionId=" + regionId + "&serverIp=" + serverIp, axiosRequestWithAuth)
        .then(resp => {
            return resp.status;
        }).catch(function (error) {
            return false;
        });
}

async function rebootServer(serverId, regionUrl, rebootType) {
    let requestBody = {
        reboot: {
            type: rebootType
        }
    };
    requestBody = JSON.stringify(requestBody);
    return await axiosInstance.post(`/server/default/` + getUserId() + '/' + serverId + '?region=' + regionUrl, requestBody, axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false;
        });
}

async function startServer(serverId, regionUrl) {
    let requestBody = {};
    requestBody = JSON.stringify(requestBody);
    return await axiosInstance.post(`/server/start/` + getUserId() + '/' + serverId + '?region=' + regionUrl, requestBody, axiosRequestWithAuth)
        .then(resp => {
            return true;
        }).catch(function (error) {
            return false;
        });
}

async function stopServer(serverId, regionUrl) {
    let requestBody = {};
    requestBody = JSON.stringify(requestBody);
    return await axiosInstance.post(`/server/stop/` + getUserId() + '/' + serverId + '?region=' + regionUrl, requestBody, axiosRequestWithAuth)
        .then(resp => {
            return resp;
        }).catch(function (error) {
            return false;
        });
}

async function launchConsole(serverId, regionUrl) {
    return await axiosInstance.post(`/server/` + getUserId() + '/' + serverId + '/console?region=' + regionUrl, {}, axiosRequestWithAuth)
        .then(resp => {
            return resp.data.remote_console;
        }).catch(function (error) {
            return false;
        });
}

function getlcUrl(serverId, servername, regionUrl, type) {
    return API_HOST + `/server/console/` + serverId + "/" + getUserId() + '?region=' + regionUrl + '&name=' + servername + '&type=' + type;
}

async function getlcUrl_v2(serverId, servername, regionUrl, type) {
    return await axiosInstance.get(API_HOST + `/server/console/` + serverId + "/" + getUserId() + '?region=' + regionUrl + '&name=' + servername + '&type=' + type, axiosRequestWithAuth).then(resp => {
        return resp.data;
    }).catch(error => {
        return false;
    });
}

async function serverAction(serverId, regionUrl, requestBody) {
    requestBody = JSON.stringify(requestBody);
    return await axiosInstance.post(`/server/default/` + getUserId() + '/' + serverId + '?region=' + regionUrl, requestBody, axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            throw error;
        });
}

function serverActionResize(serverId, regionUrl, planType, requestBody, type, regionCode) {
    requestBody = JSON.stringify(requestBody);
    return fetch(API_HOST + `/resize/` + getUserId() + '/' + serverId + '/' + type + '/' + planType + '/' + regionCode + '?region=' + regionUrl,
        {
            credentials: 'include',
            timeout: 100000,
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'Accept': '*/*',
                'Access-Control-Allow-Origin': '*',
            },
            body: requestBody
        }
    ).then((response) =>
        response.json())
        .then((resp) => {
            return resp;
        })
        .catch((error) => {
            console.error(error);
            return false;
        });
}

async function serverActionResize_v2(serverId, regionUrl, planType, requestBody, type, regionCode) {
    requestBody = JSON.stringify(requestBody);
    let config = axiosRequestWithAuth;
    config['timeout'] = 100000;
    return await axiosInstance.post(`/resize/` + getUserId() + '/' + serverId + '/' + type + '/' + planType + '/' + regionCode + '?region=' + regionUrl, requestBody, config).then(resp => {
        return resp.data;
    }).catch(error => {
        console.error(error);
        return false;
    });
};

async function serverActionRebuild(serverId, regionUrl, name, requestBody, regionId) {
    requestBody = JSON.stringify(requestBody);
    return await axiosInstance.post(`/server/rebuild/` + getUserId() + '/' + serverId + '?region=' + regionUrl + '&insname=' + name + "&regionid=" + regionId, requestBody, axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(error => {
            return false;
        });
}

async function migration(serverId, destRegion, srcRegion, field) {
    return await axiosInstance.post(`/server/migration/` + serverId + '/' + field + '/' + getUserId() + '?destRegion=' + destRegion + '&srcRegion=' + srcRegion, {}, axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(error => {
            return false;
        });
}

async function instReject(instanceId, region) {
    return await axiosInstance.get(`/inst-migration/revert/` + instanceId + '/' + getUserId() + '/?region=' + region, axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(error => {
            return false;
        });
}

async function getActivities(regionUrl, instanceId) {
    return await axiosInstance.get(`/server/` + getUserId() + '/' + instanceId + '/logs?region=' + regionUrl, axiosRequestWithAuth)
        .then(resp => {
            let actionList = [];
            if(resp.data !== undefined && resp.data.instanceActions !== undefined) {
                actionList = resp.data.instanceActions;
                actionList.forEach(item => {
                    if(!item.start_time.includes('Z')) {
                        item.start_time = item.start_time + 'Z';
                    }
                    item.start_time = getLocalTime(item.start_time);
                });
            }
            return resp.data.instanceActions;
        }).catch(function (error) {
            return false;
        });
}

async function updateServer(instanceId, regionUrl, requestBody) {
    requestBody = JSON.stringify(requestBody);
    return await axiosInstance.put(`/server/` + getUserId() + '/' + instanceId + '?region=' + regionUrl, requestBody, axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false;
        });
}
async function submitBmr(requestBody) {
    requestBody = JSON.stringify(requestBody);
    return await axiosInstance.post(`/baremetal/requestbmr/` + getUserId(), requestBody, axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false;
        });
}

function getPublicIpAddress(addresses) {
    let publicProvider = addresses['provider.public'];
    let publicIpv4Address = [];
    if(publicProvider && publicProvider.length > 0) {
        for(let i = 0; i < publicProvider.length; i++) {
            let element = publicProvider[i];
            if(element.version === 4) {
                publicIpv4Address.push(element.addr);

            }

        }
    }
    else {
        publicIpv4Address.push('NA');
    }
    return publicIpv4Address;
}

async function isSurveyEnabled() {
    let reqHeaders = axiosRequestWithAuth;
    return await axiosInstance.get('/survey/is-enabled', reqHeaders)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            console.log("error :" + JSON.stringify(error));
            return error;
        });
}

async function getSurvey() {
    let reqHeaders = axiosRequestWithAuth;
    return await axiosInstance.get('/survey/' + getUserId(), reqHeaders)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            console.log("error :" + JSON.stringify(error));
            return error;
        });
}

async function createSurvey(requestBody) {
    let reqHeaders = axiosRequestWithAuth;
    return await axiosInstance.post('/survey/' + getUserId(), requestBody, reqHeaders)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            console.log("error :" + JSON.stringify(error));
            return error;
        });
}

async function getSureyList() {
    let reqHeaders = axiosRequestWithAuth;
    return await axiosInstance.get('/survey', reqHeaders)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            console.log("error :" + JSON.stringify(error));
            return error;
        });
}

async function deleteSurveyById() {
    let reqHeaders = axiosRequestWithAuth;
    return await axiosInstance.delete('/survey/' + getUserId(), reqHeaders)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            console.log("error :" + JSON.stringify(error));
            return error;
        });
}

async function getAllKbInfo() {
    let reqHeaders = axiosRequestWithAuth;
    return await axiosInstance.get('/images/appstackimage-info', reqHeaders)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            console.log("error :" + JSON.stringify(error));
            return [];
        });
}


export default ServerService;
